import { render, staticRenderFns } from "./parmFile.vue?vue&type=template&id=2945e19b&scoped=true&"
import script from "./parmFile.vue?vue&type=script&lang=js&"
export * from "./parmFile.vue?vue&type=script&lang=js&"
import style0 from "./parmFile.vue?vue&type=style&index=0&id=2945e19b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2945e19b",
  null
  
)

export default component.exports